function scrollToEl(elementName, offset = 0) {
  // Находим элемент по атрибуту name
  const target = document.querySelector(`[name="${elementName}"]`);

  if (target) {
    // Рассчитываем позицию элемента с учетом отступа
    const topPosition =
      target.getBoundingClientRect().top + window.pageYOffset - offset;

    // Плавный скролл
    window.scrollTo({
      top: topPosition,
      behavior: "smooth",
    });
  }
}

window.scrollToEl = scrollToEl;
